<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper compact-wrapper" id="pageWrapper">
    <div class="page-body-wrapper">
      <div class="page-body">
        <!-- Breadcrumb & Title -->
        <div class="container-fluid">
          <div class="page-title">
            <div class="row">
              <div class="col-12 col-sm-6">
                <h3>Invoice Records</h3>
              </div>
              <div class="col-12 col-sm-6">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a class="home-item" href="/"><i data-feather="home"></i></a>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                  <li class="breadcrumb-item active">Invoice List</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb & Title -->

        <!-- Container-fluid starts-->
        <div class="container-fluid list-products">
          <div class="row">
            <!-- Data table -->
            <div class="col-sm-12 col-lg-12">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>List</h5>
                  <span>Invoice List</span>
                </div>
                <div class="card-body">
                  <div class="table-responsive product-tabl">
                    <table class="display w-100" id="invoiceListTBL">
                      <thead>
                        <tr align="center">
                          <th>#</th>
                          <th>Mushok</th>

                          <th>Invoice type</th>
                          <th>Sub. Total</th>
                          <th>Payment status</th>
                          <th>Invoice PDF</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          align="center"
                          v-for="(item, index) in invoice_list"
                          :key="index"
                        >
                          <td>{{ "#" + item.inv_no }}</td>
                          <td>{{ item.mushok }}</td>
                          <td>{{ item.inv_type ? "Manual" : "Automatic" }}</td>
                          <td>{{ parseInt(item.sub_total_price) }}</td>

                          <td>
                            <span
                              class="badge badge-success"
                              v-if="item.paid_status === 1"
                              >Paid</span
                            >
                            <span
                              class="badge badge-warning"
                              v-if="item.paid_status === 0"
                              >Unpaid</span
                            >
                          </td>
                          <td>
                            <button
                              class="btn btn-sm btn-primary"
                              @click="downloadPDF(item)"
                            >
                              Download
                            </button>
                          </td>
                          <td>
                            <!-- <button
                              class="btn btn-danger btn-xs"
                              type="button"
                              data-original-title="btn btn-danger btn-xs"
                              title=""
                              @click.prevent="deleteType(item.id)"
                            >
                              Delete
                            </button> -->
                            <button
                              class="btn btn-primary btn-xs"
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModal1"
                              @click.prevent="selectedAction(item.items)"
                            >
                              <span class="title"> Details</span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Container-fluid starts-->
        <!-- Modal -->
        <div
          class="modal fade"
          id="exampleModal1"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel1"
          aria-hidden="true"
          v-show="this.selectedItem?.length !== 0"
        >
          <div class="modal-dialog modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel1">Invoice Items</h5>
                <button
                  class="btn-close"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <form class="form-bookmark">
                  <div class="row g-2">
                    <div class="mb-3 col-md-12">
                      <div class="table-responsive product-tabl">
                        <table class="display w-100" id="invoiceListTBL">
                          <thead>
                            <!-- <th>Invoice</th> -->
                            <th>Bill from Date</th>
                            <th>Bill to Date</th>
                            <th>Bill from Date</th>
                            <th>Price</th>
                            <th>Note</th>
                          </thead>
                          <tbody>
                            <tr v-for="item in selectedItem" :key="item.id">
                              <!-- <td>{{ '#' + item.invoice_id }}</td> -->
                              <td>{{ item.bill_from_date }}</td>
                              <td>{{ item.bill_to_date }}</td>
                              <td>
                                {{ item.calculation_method === 2 ? "Auto" : "Manual" }}
                              </td>
                              <td>{{ parseInt(item.price) }}</td>
                              <td>{{ item.note }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import Moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import $ from "jquery";
import customerAPI from "../../services/customer.API.js";

export default {
  name: "CustomerList",
  components: {},
  data() {
    return {
      invoice_list: [],
    };
  },
  methods: {
    // district list
    getList() {
      customerAPI.getList().then(
        (response) => {
          this.customerList = response.data.data;
          console.log(response.data.data);
        },
        (err) => {
          if (err.response.data.success === false) {
            this.customerList = [];
          }
        }
      );
    },

    // delete
    deleteType(id) {
      if (id) {
        customerAPI.deleteCustomer(id).then(
          (response) => {
            this.$moshaToast(response.data.message, {
              type: "success",
              position: "top-right",
              showIcon: true,
            });
            // get all connection type
            customerAPI.getList().then((response) => {
              this.customerList = response.data.data;
            });
          },
          (err) => {
            this.$moshaToast(err.response.data.message, {
              type: "danger",
              position: "top-right",
              showIcon: true,
            });
          }
        );
      } else {
        this.$moshaToast("Please select service type", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      }
    },

    // change status
    changeStatus(id) {
      if (id) {
        customerAPI.changeStatus(id).then(
          (response) => {
            this.$moshaToast(response.data.message, {
              type: "success",
              position: "top-right",
              showIcon: true,
            });
            // get all connection type
            customerAPI.getList().then((response) => {
              this.customerList = response.data.data;
            });
          },
          (err) => {
            this.$moshaToast(err.response.data.message, {
              type: "danger",
              position: "top-right",
              showIcon: true,
            });
          }
        );
      } else {
        this.$moshaToast("Please select connection type", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      }
    },
    // download pdf
    downloadPDF(itemData) {
      if (itemData) {
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "portrait"; // portrait or landscape

        // header/body data
        const columns = [
          [
            "#",
            "Bill from date",
            "Bill to date",
            "Initial date",
            "Note",
            "Price",
            "Year",
          ],
        ];
        const data = itemData.items.map((e, i) => [
          i + 1,
          Moment(e.bill_from_date).format("DD-MM-YYYY"),
          Moment(e.bill_to_date).format("DD-MM-YYYY"),
          Moment(e.initial_date).format("DD-MM-YYYY"),
          e.note,
          parseInt(e.price),
          e.year,
        ]);

        // alignment
        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);
        // new line
        // var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
        doc.setFontSize(13);

        doc.text("#" + itemData.inv_no, 40, 85);
        doc.setFontSize(10);

        doc.text("Mushok Number : " + itemData.mushok_no, 40, 105);
        doc.text("Mushok : " + parseInt(itemData.mushok), 40, 125);
        if (itemData.paid_status === 0) {
          doc.text("Payment Status : Unpaid", 40, 145);
        } else {
          doc.text("Payment Status : Paid", 40, 145);
        }
        doc.text("Sub-Total : " + parseInt(itemData.sub_total_price), 40, 165);
        doc.text("Total : " + parseInt(itemData.total_price), 40, 185);
        doc.setFontSize(15);
        var startingPage = doc.internal.getCurrentPageInfo().pageNumber;
        const title = "Report";

        let content = {
          startY: 220,
          head: columns,
          body: data,
          margin: {
            bottom: 120,
            top: 150,
          },
        };

        doc.setFont("helvetica", "bold");
        doc.setFontSize(15);
        doc.text(title, marginLeft, 50);

        doc.autoTable(content);

        doc.setPage(startingPage);
        doc.save("Invoice_Report(" + Moment(new Date()).format("YYYY-MM-DD") + ").pdf"); // Auto print code
        doc.autoPrint();
      }
    },

    selectedAction(item) {
      this.selectedItem = item.map((e) => {
        return {
          ...e,
          bill_from_date: Moment(e.bill_from_date).format("DD-MM-YYYY"),
          bill_to_date: Moment(e.bill_to_date).format("DD-MM-YYYY"),
          initial_date: Moment(e.initial_date).format("DD-MM-YYYY"),
        };
      });
    },
  },
  mounted() {
    //   list
    customerAPI.invoiceListOwn().then((res) => {
      if (res?.data?.data) {
        this.invoice_list = res.data.data.invoiceData;
        setTimeout(() => {
          $("#invoiceListTBL").DataTable({
            lengthMenu: [
              [10, 25, 50, -1],
              [10, 25, 50, "All"],
            ],
            pageLength: 10,
            info: false,
            targets: "no-sort",
            bSort: false,
            order: [],
            bFilter: true,
            bInfo: false,
            //   bLengthChange: false,
            bDestroy: true,
          });
        });
      }
    });
  },
};
</script>

<style scoped>
.btn {
  margin: 5px;
}

th {
  text-align: center !important;
}

span.switch-state:before {
  background: #000 !important;
  margin-bottom: -2px !important;
}

span.switch-state {
  border: 2px solid #000 !important;
}

th {
  text-align: center !important;
}

th,
td {
  text-align: center;
  border: 1px solid #f3f3f3;
  padding: 10px 0;
}
</style>
